"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateContractsInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const types_1 = require("@framework/types");
const TemplateContractsInput = (props) => {
    const { contractType = [], contractModule = [] } = props;
    const contractIds = (0, react_hook_form_1.useWatch)({ name: "contractIds" });
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "templateIds", controller: "templates", fetchData: {
            contractIds,
            contractType,
            contractModule,
            templateStatus: [types_1.TemplateStatus.ACTIVE, types_1.TemplateStatus.HIDDEN],
        }, multiple: true }));
};
exports.TemplateContractsInput = TemplateContractsInput;
//# sourceMappingURL=index.js.map